import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomSorting,
  CustomTable,
  CustomTableContainer,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import { CustomStack, CustomTextField, SectionWrapper } from '@components/Styles/CommonStyle';
import { MenuItem, Select, TableBody, TableHead, TextField, Typography } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { CustomButton } from '@components/Styles/ButtonStyle';
import React from 'react';
import { theme } from '@components/Styles/theme';
import { formatAmount } from '@utils/formatter';
import Pagination from '../Shared/Pagination';

const SalesTable = ({
  getMonthlyFinanceList,
  monthlyFinanceList,
  monthlyFinanceListTotal,
  monthlyFinanceListTotalAmount,
  projectName,
  companyName,
  setProjectName,
  setCompanyName,
  page,
  setPage,
  limit,
  setLimit,
  orderBy,
  setOrderBy,
  orderDir,
  setOrderDir
}) => {
  // 공급금액 총합
  const totalSupplyAmount = monthlyFinanceListTotalAmount;
  // 부가세 총합
  const totalVatAmount = Math.ceil(monthlyFinanceListTotalAmount * 0.1);
  // 공급금액과 부가세 총합의 합
  const totalAmount = totalSupplyAmount + totalVatAmount;

  return (
    <React.Fragment>
      <SectionWrapper>
        <CustomStack mb={2}>
          <Typography sx={theme.typography.h4}>검색</Typography>
        </CustomStack>
        <CustomTableContainer>
          <CustomTable>
            <TableBody>
              <CustomTableRow>
                <CustomHeaderCell>매출처</CustomHeaderCell>
                <CustomBodyCell>
                  <CustomTextField
                    size="small"
                    placeholder="매출처"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        getMonthlyFinanceList();
                      }
                    }}
                  />
                </CustomBodyCell>
                <CustomHeaderCell>사업명</CustomHeaderCell>
                <CustomBodyCell>
                  <CustomTextField
                    size="small"
                    placeholder="사업명"
                    value={projectName}
                    onChange={(e) => setProjectName(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        getMonthlyFinanceList();
                      }
                    }}
                  />
                </CustomBodyCell>
              </CustomTableRow>
            </TableBody>
          </CustomTable>
        </CustomTableContainer>
        <CustomStack justifyContent="center" mt={2}>
          <CustomButton type="search" onClick={getMonthlyFinanceList}>
            검색
          </CustomButton>
        </CustomStack>
      </SectionWrapper>

      <SectionWrapper>
        <CustomStack gap="20px" mb={2}>
          <CustomStack>
            <Typography variant="subtitle1" fontWeight="700">
              총금액:
            </Typography>
            <Typography variant="body1">{formatAmount(totalAmount)}원</Typography>
          </CustomStack>
          <CustomStack>
            <Typography variant="subtitle1" fontWeight="700">
              공급금액:
            </Typography>
            <Typography variant="body1">{formatAmount(totalSupplyAmount)}원</Typography>
          </CustomStack>
          <CustomStack>
            <Typography variant="subtitle1" fontWeight="700">
              부가세:
            </Typography>
            <Typography variant="body1">{formatAmount(totalVatAmount)}원</Typography>
          </CustomStack>
        </CustomStack>

        <CustomTableContainer>
          <CustomTable>
            <TableHead>
              <CustomTableRow>
                <CustomHeaderCell align="center">No</CustomHeaderCell>
                <CustomHeaderCell scope="row" align="center">
                  매출처
                  {
                    orderBy === 'pmfl_account_company_name' && orderDir === 'ASC' ? (
                      <CustomSorting
                        sorted
                        onClick={() => {
                          setOrderBy('pmfl_account_company_name');
                          setOrderDir('DESC');
                        }}
                      >
                        <KeyboardArrowUpIcon />
                      </CustomSorting>
                    ) : orderBy === 'pmfl_account_company_name' && orderDir === 'DESC' ? (
                      <CustomSorting
                        sorted
                        onClick={() => {
                          setOrderBy('pmfl_account_company_name');
                          setOrderDir('ASC');
                        }}
                      >
                        <KeyboardArrowDownIcon />
                      </CustomSorting>
                    ) : (
                      <CustomSorting
                        onClick={() => {
                          setOrderBy('pmfl_account_company_name');
                          setOrderDir('ASC');
                        }}
                      >
                        <KeyboardArrowUpIcon />
                      </CustomSorting>
                    )
                  }
                </CustomHeaderCell>
                <CustomHeaderCell scope="row" align="center">
                  사업명
                  {
                    orderBy === 'pl.project_name' && orderDir === 'ASC' ? (
                      <CustomSorting
                        sorted
                        onClick={() => {
                          setOrderBy('pl.project_name');
                          setOrderDir('DESC');
                        }}
                      >
                        <KeyboardArrowUpIcon />
                      </CustomSorting>
                    ) : orderBy === 'pl.project_name' && orderDir === 'DESC' ? (
                      <CustomSorting
                        sorted
                        onClick={() => {
                          setOrderBy('pl.project_name');
                          setOrderDir('ASC');
                        }}
                      >
                        <KeyboardArrowDownIcon />
                      </CustomSorting>
                    ) : (
                      <CustomSorting
                        onClick={() => {
                          setOrderBy('pl.project_name');
                          setOrderDir('ASC');
                        }}
                      >
                        <KeyboardArrowUpIcon />
                      </CustomSorting>
                    )
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  공급금액
                  {
                    orderBy === 'pmfl_sales_amount' && orderDir === 'ASC' ? (
                      <CustomSorting
                        sorted
                        onClick={() => {
                          setOrderBy('pmfl_sales_amount');
                          setOrderDir('DESC');
                        }}
                      >
                        <KeyboardArrowUpIcon />
                      </CustomSorting>
                    ) : orderBy === 'pmfl_sales_amount' && orderDir === 'DESC' ? (
                      <CustomSorting
                        sorted
                        onClick={() => {
                          setOrderBy('pmfl_sales_amount');
                          setOrderDir('ASC');
                        }}
                      >
                        <KeyboardArrowDownIcon />
                      </CustomSorting>
                    ) : (
                      <CustomSorting
                        onClick={() => {
                          setOrderBy('pmfl_sales_amount');
                          setOrderDir('ASC');
                        }}
                      >
                        <KeyboardArrowUpIcon />
                      </CustomSorting>
                    )
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">부가세</CustomHeaderCell>
                <CustomHeaderCell align="center">합계금액</CustomHeaderCell>
              </CustomTableRow>
            </TableHead>
            <TableBody>
              {monthlyFinanceList.length > 0 ? (
                monthlyFinanceList.map((item, index) => {
                  return (
                    <CustomTableRow>
                      <CustomBodyCell align="center">{monthlyFinanceListTotal - ((page - 1) * limit + index)}</CustomBodyCell>
                      <CustomBodyCell align="center">{item.pmfl_account_company_name}</CustomBodyCell>
                      <CustomBodyCell>{item.project_name}</CustomBodyCell>
                      <CustomBodyCell align="right">{formatAmount(item.pmfl_sales_amount)}원</CustomBodyCell>
                      <CustomBodyCell align="right">
                        {formatAmount(Math.ceil(item.pmfl_sales_amount * 0.1))}원
                      </CustomBodyCell>
                      <CustomBodyCell align="right">
                        {formatAmount(item.pmfl_sales_amount + Math.ceil(item.pmfl_sales_amount * 0.1))}원
                      </CustomBodyCell>
                    </CustomTableRow>
                  );
                })
              ) : (
                <CustomTableRow>
                  <CustomBodyCell colSpan={6} align="center">
                    조회된 매출 내역이 없습니다.
                  </CustomBodyCell>
                </CustomTableRow>
              )}
            </TableBody>
          </CustomTable>

          <Select
              sx={{ mt: 2, width: '100px', height: '40px' }}
              value={limit}
              onChange={(e) => setLimit(e.target.value)}
            >
              {/* <MenuItem value={1}>1</MenuItem> */}
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={30}>30</MenuItem>
            </Select>

          <Pagination count={Math.ceil(monthlyFinanceListTotal / limit) || 1} page={page} onChange={getMonthlyFinanceList} />
        </CustomTableContainer>
      </SectionWrapper>
    </React.Fragment>
  );
};

export default SalesTable;
